import { inject, Injectable, Type } from '@angular/core';
import { FpLoggerNoiseTabs } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/enums/fp-logger-noise-tabs.enum';
import { IFpLoggerNoiseTabConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/interfaces/fp-logger-noise-tab-connect-service';
import { FpLoggerNoiseSpectrumStore } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-spectrum/services/fp-logger-noise-spectrum/fp-logger-noise-spectrum.store';
import { FpLoggerNoiseSpectrumActionType } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-spectrum/services/fp-logger-noise-spectrum/fp-logger-noise-spectrum.actions';
import { FpLoggerNoiseSpectrumComponent } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-spectrum/components/fp-logger-noise-spectrum/fp-logger-noise-spectrum.component';
import { FpLoggerNoiseSpectrumMinimizedComponent } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-spectrum/components/fp-logger-noise-spectrum-minimized/fp-logger-noise-spectrum-minimized.component';
import { Observable } from 'rxjs';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';

@Injectable()
export class FpLoggerNoiseSpectrumConnectService implements IFpLoggerNoiseTabConnectService {
  protected tabStore = inject(FpLoggerNoiseSpectrumStore);
  public currentTab = FpLoggerNoiseTabs.SignalSpectrum;

  public component: Type<unknown> = FpLoggerNoiseSpectrumComponent;
  public minimizedComponent: Type<unknown> = FpLoggerNoiseSpectrumMinimizedComponent;

  public localLoading(): Observable<boolean> {
    return this.tabStore.loading$;
  }

  public isChartFullscreen(): Observable<boolean> {
    return this.tabStore.isChartFullscreenActive$;
  }

  public isActive(tab: FpLoggerNoiseTabs): boolean {
    return this.currentTab === tab;
  }

  public initData(selectedDate: string, selectedData: ILdLogger): void {
    this.tabStore.dispatch({
      type: FpLoggerNoiseSpectrumActionType.GetData,
      date: selectedDate,
      popupMainData: selectedData,
    });
  }

  public updateData(selectedDate: string, selectedData: ILdLogger): void {
    this.tabStore.dispatch({
      type: FpLoggerNoiseSpectrumActionType.GetData,
      date: selectedDate,
      popupMainData: selectedData,
    });
  }
}
